'use client';
import React from 'react';
import { useSearchParams, useRouter } from 'next/navigation';
import BackButton from './BackButton';

type ClientWrapperProps = {
	baseUrl: string;
	defaultUrl: string;
	buttonText: string;
};

const ClientWrapper = ({ baseUrl, defaultUrl, buttonText }: ClientWrapperProps) => {
	const searchParams = useSearchParams();
	const router = useRouter();
	const category = searchParams.get('category');
	const subcategory = searchParams.get('subcategory');

	const handleGoBack = () => {
		const backUrl =
			category && subcategory ? `${baseUrl}?category=${category}&subcategory=${subcategory}` : defaultUrl;
		router.push(backUrl);
	};

	return <BackButton onGoBack={handleGoBack} text={buttonText} />;
};

export default ClientWrapper;
